export const createSeriesLoadGenerationCoordinator = () => {
  let currentGeneration = 0;

  const begin = () => {
    currentGeneration += 1;
    return currentGeneration;
  };

  const isCurrent = generation => generation === currentGeneration;

  const resolve = async (generation, operation) => {
    const value = await operation();
    return isCurrent(generation)
      ? { accepted: true, value }
      : { accepted: false, value: undefined };
  };

  const continueCurrent = (generation, continuation) => {
    if (!isCurrent(generation)) return false;
    continuation();
    return true;
  };

  return {
    begin,
    isCurrent,
    resolve,
    continue: continueCurrent,
    invalidate: begin,
  };
};
